module.exports = __webpack_public_path__ + "static/fcra-2015-16-q3-40e816fd0b5f545a194ee51a98e3f587.pdf";